const QrPreview = ({ svgDataUrl }) => {
  if (!svgDataUrl) {
    return (
      <div className="w-full rounded-xl border border-dashed border-slate-300 bg-slate-50 px-4 py-6 text-center text-sm font-semibold text-slate-500">
        Gere um QR Code para visualizar aqui.
      </div>
    );
  }

  return (
    <div className="grid justify-items-center gap-3 rounded-2xl bg-gradient-to-br from-indigo-50 to-slate-50 p-4 shadow">
      <figure className="w-full max-w-xs rounded-2xl bg-white p-4 shadow-inner">
        <img src={svgDataUrl} alt="QR Code" className="mx-auto h-auto w-full rounded-lg bg-white" />
      </figure>
    </div>
  );
};

export default QrPreview;
